import { withHeaders } from './with-headers';

const LANGUAGE_HEADER = 'x-ui-language';
const REGION_HEADER = 'x-ui-region';

export const withI18nHeaders = withHeaders(context => {
  const headers = {};

  if (context.language) {
    headers[LANGUAGE_HEADER] = context.language;
  }

  if (context.region) {
    headers[REGION_HEADER] = context.region;
  }

  return headers;
});
